import classNames from "classnames";
import { useTranslation } from "react-i18next";
import AddBoxOutlinedIcon from "@mui/icons-material/AddBoxOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import IconButton from "features/components/IconButton";
import Tooltip from "features/components/Tooltip";

interface Props {
  id: string;
  onNewRow: (id: string) => void;
  onNewGroup: (id: string) => void;
  onDelete?: (id: string) => void;
  disabled?: boolean;
  hideAddGroupCta?: boolean;
  hasInputFocus?: boolean;
  isGroup?: boolean;
}

const RowActions = ({
  id,
  onNewRow,
  onNewGroup,
  onDelete,
  disabled,
  hideAddGroupCta,
  hasInputFocus,
  isGroup = false,
}: Props) => {
  const { t } = useTranslation("filters");

  return (
    <div
      className={classNames("flex flex-nowrap", {
        "invisible pointer-events-none": !hasInputFocus,
        "visible pointer-events-auto": hasInputFocus,
        // added at the end because of css class ordering
        "group-hover/row:visible group-hover/row:pointer-events-auto group-hover/group:visible group-hover/group:pointer-events-auto": true,
      })}
      data-testid="filter-row-actions"
    >
      <Tooltip title={t("actions.add_comparison_level")}>
        <IconButton
          onClick={() => onNewRow(id)}
          size="small"
          data-testid="filter-action-add-row"
          disabled={disabled}
        >
          <AddOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>

      {!hideAddGroupCta && (
        <Tooltip title={t("actions.add_group_level")}>
          <IconButton
            onClick={() => onNewGroup(id)}
            size="small"
            data-testid="filter-action-add-group"
            disabled={disabled}
          >
            <AddBoxOutlinedIcon fontSize="inherit" />
          </IconButton>
        </Tooltip>
      )}

      <Tooltip
        title={
          isGroup ? t("actions.delete_group") : t("actions.delete_comparison")
        }
      >
        <IconButton
          disabled={!onDelete || disabled}
          onClick={onDelete ? () => onDelete(id) : undefined}
          size="small"
          data-testid="filter-action-delete"
        >
          <DeleteOutlineOutlinedIcon fontSize="inherit" />
        </IconButton>
      </Tooltip>
    </div>
  );
};

export default RowActions;
